import React from "react";
import {
  isMaintenanceMode,
  MAINTENANCE_BANNER_TEXT,
} from "../utils/maintenance";
import { FaTools } from "react-icons/fa";

const MaintenanceBanner = () => {
  if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line no-console
    console.log(
      "REACT_APP_MAINTENANCE_MODE:",
      process.env.REACT_APP_MAINTENANCE_MODE
    );
  }
  if (!isMaintenanceMode()) return null;
  return (
    <div className="maintenance-banner" role="status" aria-live="polite">
      <div className="maintenance-banner-content">
        <FaTools className="maintenance-icon" />
        <span className="maintenance-title">Maintenance Mode</span>
        <span className="maintenance-text">{MAINTENANCE_BANNER_TEXT}</span>
      </div>
    </div>
  );
};

export default MaintenanceBanner;
